import { render, staticRenderFns } from "./IndustryNewsDetails.vue?vue&type=template&id=11c68e68&scoped=true&"
import script from "./IndustryNewsDetails.vue?vue&type=script&lang=js&"
export * from "./IndustryNewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./IndustryNewsDetails.vue?vue&type=style&index=0&id=11c68e68&scoped=true&lang=less&"
import style1 from "./IndustryNewsDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c68e68",
  null
  
)

export default component.exports